export interface ProviderOptionData {
  prefix?: string;
  suffix?: string;
  firstName: string;
  lastName: string;
  specialty: string;
  location: string;
}

export interface SearchCategory {
  name: string;
  items: SearchItem[];
}

export interface SearchItem {
  categoryType: string;
  name: string;
  subItems?: SearchItem[];
}

export const allProviders = (): ProviderOptionData[] => {
  return [
    {
      firstName: 'John',
      lastName: 'Lendo',
      specialty: 'Opthamologist',
      location: 'Green Lake - Eye care',
      suffix: 'DO',
    },
    {
      firstName: 'Dennis',
      lastName: 'Renalt',
      specialty: 'Cardiologist',
      location: '2500 San Jacinto Ave #450',
      suffix: 'MD',
    },
    {
      firstName: 'Kam',
      lastName: 'Kamjoo',
      specialty: 'Cardiologist',
      location: '2500 San Jacinto Ave #450',
      suffix: 'MD',
    },
    {
      firstName: 'Davin',
      lastName: 'Lunder',
      specialty: 'Cardiologist',
      location: '3400 Cesar Chavez Blvd',
      suffix: 'MD',
    },
    {
      firstName: 'Ramandeep',
      lastName: 'Kaur',
      specialty: 'Cardiologist',
      location: '3400 Cesar Chavez Blvd',
      suffix: 'MD',
    },
    {
      firstName: 'Stephen',
      lastName: 'Hart',
      specialty: 'Cardiologist',
      location: '3400 Cesar Chavez Blvd',
      suffix: 'MD',
    },
    {
      firstName: 'David',
      lastName: 'Ramin',
      specialty: 'Cardiologist',
      location: '2500 San Jacinto Ave #450',
      suffix: 'MD',
    },
    {
      firstName: 'Madeline',
      lastName: 'Ricci',
      specialty: 'Cardiologist',
      location: '3400 Cesar Chavez Blvd',
      suffix: 'MD',
    },
    {
      firstName: 'Mary Ann',
      lastName: 'Chriqui',
      specialty: 'Cardiologist',
      location: '3400 Cesar Chavez Blvd',
      suffix: 'OD',
    },
  ];
};

export const allCategories = (): SearchCategory[] => {
  const medicalSpecialties: SearchItem[] = [
    { name: 'Primary Care Physician (PCP)' },
    { name: 'OB-GYN (Obstetrician-Gynecologist)' },
    {
      name: 'Cardiologist',
      subItems: [
        {
          name: 'High blood pressure',
        },
        {
          name: 'MRI (Cardiology)',
        },
        {
          name: 'High cholesterol consultation',
        },
        {
          name: 'Shortness of breath',
        },
        {
          name: 'Cardiovascular disease',
        },
        {
          name: 'Hypertension',
        },
        {
          name: 'Chest pain',
        },
        {
          name: 'Lowered heart rate (Bradycardia)',
        },
        {
          name: 'X-ray visit',
        },
        {
          name: 'Limping (Claudication)',
        },
      ].map((item) => {
        return { ...item, categoryType: 'Symptom' };
      }),
    },
    { name: 'Dermatologist' },
    { name: 'Dentist' },
    { name: 'Ear, Nose & Throat Doctor (ENT / Otolaryngologist)' },
    { name: 'Eye Doctor' },
    { name: 'Psychiatrist' },
    { name: 'Orthopedic Surgeon (Orthopedist)' },
  ].map((item) => {
    return { ...item, categoryType: 'Specialty' };
  });

  const specialtyCategory: SearchCategory = {
    name: 'Popular Medical Specialties',
    items: medicalSpecialties,
  };

  const symptoms: SearchItem[] = [
    { name: 'abdoimnal redness' },
    { name: 'Abdominal pain' },
    { name: 'Abnormal sweating' },
    { name: 'abnormal vaginal bleeding' },
    { name: 'acne' },
    { name: 'adbdominal swelling' },
    { name: 'allergy' },
    { name: 'anal fissure' },
    { name: 'anal pain' },
    { name: 'anemia' },
    { name: 'anhedonia' },
    { name: 'ankle pain' },
    { name: 'anxiety' },
    { name: 'appendicitis' },
    { name: 'arm pain' },
    { name: 'arm swelling' },
    { name: 'arm weakness' },
    { name: 'armpit pain' },
    { name: 'armpit swelling' },
    { name: 'asthma' },
    { name: 'attention deficit' },
    { name: 'back pain' },
    { name: 'blindness' },
    { name: 'blurred vision' },
    { name: 'chest pain' },
    { name: 'chills' },
    { name: 'chronic pain' },
    { name: 'cold' },
    { name: 'confusion' },
    { name: 'constipation' },
    { name: 'cool bluish skin' },
    { name: 'cough' },
    { name: 'covid-19' },
    { name: 'decreased appetite' },
    { name: 'decreased hearing' },
    { name: 'decreased smell' },
    { name: 'decreased taste' },
    { name: 'decreased urination' },
    { name: 'decreased vision' },
    { name: 'dental pain' },
    { name: 'diabetes type 2' },
    { name: 'diarrhea' },
    { name: 'difficulty breathing (short of breath)' },
    { name: 'difficulty passing a bowel movement' },
    { name: 'difficulty sleeping' },
    { name: 'difficulty speaking' },
    { name: 'difficulty swallowing' },
    { name: 'difficulty urinating' },
    { name: 'difficulty walking' },
    { name: 'difficulty writing' },
    { name: 'dizziness' },
    { name: 'dizzy' },
    { name: 'double vision' },
    { name: 'drooping eyelid' },
    { name: 'drowsy' },
    { name: 'dry mouth' },
    { name: 'dry mucous membranes' },
    { name: 'dry skin' },
    { name: 'ear discharge' },
    { name: 'ear pain' },
    { name: 'ear pressure' },
    { name: 'ear swelling' },
    { name: 'elbow pain' },
    { name: 'emotional stress' },
    { name: 'excessive thirst' },
    { name: 'excessive tiredness' },
    { name: 'excessive urination' },
    { name: 'eye deviation' },
    { name: 'eye discharge' },
    { name: 'eye dryness' },
    { name: 'eye floaters' },
    { name: 'eye infection' },
    { name: 'eye pain' },
    { name: 'eye redness' },
    { name: 'eyelid pain' },
    { name: 'eyelid redness' },
    { name: 'eyelid swelling' },
    { name: 'facial droop' },
    { name: 'facial lesions' },
    { name: 'facial numbness or tingling' },
    { name: 'facial pain' },
    { name: 'facial swelling' },
    { name: 'fainting' },
    { name: 'fatigue' },
    { name: 'feeling cold' },
    { name: 'feeling down' },
    { name: 'fever' },
    { name: 'finger discoloration' },
    { name: 'finger pain' },
    { name: 'flank pain' },
    { name: 'flashing lights in vision' },
    { name: 'flatulence' },
    { name: 'flu' },
    { name: 'food posioning' },
    { name: 'foot fungus' },
    { name: 'foot numbness or tingling' },
    { name: 'foot pain' },
    { name: 'foot redness' },
    { name: 'foot sores' },
    { name: 'foot swelling' },
    { name: 'forearm pain' },
    { name: 'foriegn body in the eye' },
    { name: 'frequent burping' },
    { name: 'frequent night urination' },
    { name: 'frequent urination' },
    { name: 'gastroenteritis' },
    { name: 'genital lesions' },
    { name: 'goiter' },
    { name: 'gout/ gouty arthritis' },
    { name: 'groin pain' },
    { name: 'groin swelling' },
    { name: 'hair loss' },
    { name: 'hand numbness or tingling' },
    { name: 'hand pain' },
    { name: 'hand redness' },
    { name: 'hand swelling' },
    { name: 'headache' },
    { name: 'hearing issue' },
    { name: 'heart palpitations' },
    { name: 'heartburn' },
    { name: 'heavy or prolonged period' },
    { name: 'heel pain' },
    { name: 'helplessness' },
    { name: 'hot flashes' },
    { name: 'hypertension' },
    { name: 'hypothyrodism' },
    { name: 'Imbalance' },
    { name: 'inability to speak' },
    { name: 'incomplete bowel movements' },
    { name: 'influenza' },
    { name: 'insomnia' },
    { name: 'irregular periods' },
    { name: 'irritability' },
    { name: 'itchy eyes' },
    { name: 'itchy skin' },
    { name: 'jaundice' },
    { name: 'jaw clicking' },
    { name: 'jaw joint pain' },
    { name: 'jaw pain' },
    { name: 'jaw stiffness' },
    { name: 'joint pain' },
    { name: 'joint redness' },
    { name: 'joint swelling' },
    { name: 'knee pain' },
    { name: 'lack of menstruation' },
    { name: 'lack of motivation' },
    { name: 'laryngitis' },
    { name: 'late period' },
    { name: 'leg pain' },
    { name: 'leg swelling' },
    { name: 'leg weakness' },
    { name: 'lethargy' },
    { name: 'light headed' },
    { name: 'limp' },
    { name: 'lip swelling' },
    { name: 'loss of hearing' },
    { name: 'loss of taste or smell' },
    { name: 'low sex drive' },
    { name: 'lymph node swelling' },
    { name: 'major depression' },
    { name: 'malaise' },
    { name: 'mastitis' },
    { name: 'memory loss' },
    { name: 'migraine' },
    { name: 'mononucleosis' },
    { name: 'morning joint stiffness' },
    { name: 'mouth or tongue pain' },
    { name: 'mouth sores' },
    { name: 'muscle pain' },
    { name: 'muscle weakness' },
    { name: 'nasal congestion' },
    { name: 'nausea / nauseous' },
    { name: 'neck pain' },
    { name: 'numbness' },
    { name: 'one-sided paralysis' },
    { name: 'orthopnea' },
    { name: 'pain under jaw' },
    { name: 'painful bowel movements' },
    { name: 'painful intercourse' },
    { name: 'painful period' },
    { name: 'painful swallowing' },
    { name: 'pale skin' },
    { name: 'pauses in breathing' },
    { name: 'peeling skin' },
    { name: 'pelvic pain' },
    { name: 'perianal swelling' },
    { name: 'perineal pain' },
    { name: 'phelgm' },
    { name: 'plugged ears' },
    { name: 'pneumonia' },
    { name: 'poor memory' },
    { name: 'post nasal drip' },
    { name: 'preoccupation' },
    { name: 'rapid breathing' },
    { name: 'rash' },
    { name: 'recent fall' },
    { name: 'rectum pain' },
    { name: 'red areas on the leg' },
    { name: 'restlessness' },
    { name: 'rib pain' },
    { name: 'ringing ears' },
    { name: 'ringing or hissing in my ears' },
    { name: 'runny nose' },
    { name: 'scratchy throat' },
    { name: 'seizures' },
    { name: 'sexually transmitted disease' },
    { name: 'shingles' },
    { name: 'shortness of breath' },
    { name: 'shoulder blade pain' },
    { name: 'shoulder pain' },
    { name: 'sinus infection' },
    { name: 'skin infection' },
    { name: 'skin lesions' },
    { name: 'skin pain' },
    { name: 'sleepy' },
    { name: 'slurred or abnormal speech' },
    { name: 'smelly urine' },
    { name: 'sneezing' },
    { name: 'snoring' },
    { name: 'social, occupational difficulties' },
    { name: 'sore throat' },
    { name: 'stiff neck' },
    { name: 'strep throat' },
    { name: 'stroke' },
    { name: 'sweaty' },
    { name: 'swollen neck glands' },
    { name: 'teary / watery eyes' },
    { name: 'tender sinuses' },
    { name: 'thigh pain' },
    { name: 'thirsty' },
    { name: 'tingling' },
    { name: 'toe pain' },
    { name: 'toothache (tooth pain)' },
    { name: 'tremor' },
    { name: 'trouble hearing' },
    { name: 'uncontrolled crying' },
    { name: 'unusual body hair' },
    { name: 'unusual vaginal discharge' },
    { name: 'upper respiratory infection' },
    { name: 'urinary incontinence' },
    { name: 'urinary urgency' },
    { name: 'vaginal dryness' },
    { name: 'vaginal itch' },
    { name: 'vaginal pain' },
    { name: 'vaginal yeast infection' },
    { name: 'varicose verins' },
    { name: 'vomit' },
    { name: 'weakness' },
    { name: 'wrist pain' },
  ].map((item) => {
    return { ...item, categoryType: 'Symptom' };
  });

  const symptomCategory: SearchCategory = {
    name: 'Common Symptoms',
    items: symptoms,
  };

  const procedures: SearchItem[] = [
    { name: 'Appendectomy' },
    { name: 'Cataract Surgery / Refractive Lens Exchange' },
    { name: 'Colonoscopy' },
    { name: 'CT Scan' },
    { name: 'Echocardiogram' },
    { name: 'Heart Bypass Surgery' },
    { name: 'Hip Replacement Surgery' },
    { name: 'MRI' },
    { name: 'Upper Endoscopy' },
    { name: 'X-Ray' },
  ].map((item) => {
    return { ...item, categoryType: 'Procedure' };
  });

  const procedureCategory: SearchCategory = {
    name: 'Common Procedures & Surgeries',
    items: procedures,
  };

  return [specialtyCategory, symptomCategory, procedureCategory];
};
